// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"371":"3b3b8a57","877":"3b3b8a57"}[chunkId] + ".chunk.css";
};